
/**
 * 数据中心内容的selector封装，基于vue element-ui
 * @author Huanping Zhang
 * @since 2019-08-12
 */

<template>
    <div>
        <el-select
            @change="handleSelectChange"
            
            v-model="selectedDcnum" 
            
            :placeholder="placeholder"
            :name="name"
            :id="id"
            :size="selectSize"
            :class="clazz"
            :disabled="selectDisabled"
            :readonly="selectReadonly"
            :popper-append-to-body="selectPopperAppendToBody"
            
            :filterable="filterable"
            :clearable="clearable"
            >
            <el-option
               v-for="item in dcInfos"
               :key="item.id"
               :label="setLabel(item)"
               :value="item.id">
            </el-option>
        </el-select>
    </div>
</template>

<script type="text/javascript">

import * as Enumerable from 'linq';

import { Observable, Subject, BehaviorSubject  } from 'rxjs' 
import { map,mapTo,catchError,debounceTime,distinctUntilChanged } from 'rxjs/operators';

import { isIE, isEdge } from 'element-ui/src/utils/util';

import { DC } from '@/api/organization/dc';

/**
 * 
 **/
export default {
    name: 'organization.dc.select',
    components: {
    },
    props: {
        /**
         * 由父组件的v-model绑定进入,作为和父组件之间的双向绑定数据。
         *   注意，如果由v-model传入该值，则为双向绑定, selector做选择的时候会修改父组件数据的值。
         * 如果未做v-model绑定，则需要通过getCurrentValue,setCurrentValue 和监听 change事件来感知该值的变化或者做修改。
         *
         * 如果v-model绑定的是对象，或者传入的是对象,并且对象包含id属性, 则 returnObject参数会被设定为true, 数据模式自动切换到 returnObject
         */
        dcnum : [Number, String, Object],
        /** 
         * 默认为false,如果在标签中写入该属性，会自动转为 true 
         * 如果v-model绑定的是对象，或者传入的是对象，会被自动置为 true。当为true的时候，返回的内容是数据中心数据的对象，包含所有的字段。
         * 当设定为true的时候，valuePath失效。
         * 数据选择匹配的时候会自动尝试去匹配id. 匹配不到，或者绑定的对象缺失id属性，返回null
         */
        returnObject: Boolean,
        /**
         * selector 默认接受和返回 roomId, 如果需要改变值，比如返回 DCNUM, 则配置该选项到 valuePath="DCNUM"。
         *   注意，这种情况下，v-model绑定的值或者set输入的值也必须为DCNUM, 如果设定值是DCNUM，但传入或者绑定了一个 roomId,会导致显示当前已选择的内容错误。
         *       同时，如果强行选择一个新值，会导致老的roomId被修改为DCNUM的值。
         * 如果出现2级数据，比如 location.address, 则配置 valuePath="location.address"
         * 如果路径不存在，则返回null,并console打印错误。
         */
        valuePath : String,
        /**
         * selector 默认显示name内容作为label, 如果需要显示description,则配置 labelPath="description"
         * 如果出现2级数据，比如 location.address, 则配置 labelPath="location.address"
         * 如果路径不存在，则返回null,并console打印错误。同时会造成selecor 下拉菜单不显示内容( 因为全都都返回null )
         */
        labelPath : String,
        /**
         * selector 默认取全量数据中心数据(后续会计划将数据cache)。引入linq做前端where条件查询。
         */
        linqWhere : [String, Object],
    
        id   : String,
        name : String,
        size : String,
        clazz: [ String, Object],
        placeholder: {
            type: String,
            default() {
                return "请选择数据中心";
            }
        },
        popperAppendToBody:{
            type: Boolean,
            default() {
                return true;
            }
        },
        filterable: Boolean,
        clearable: Boolean,
        disabled: Boolean,
        readonly:Boolean
    }, 
    model: {
        prop: 'dcnum',
        event: 'change'
    },
    data(){
        return {
            activeName: 'pue-overview',
            selectedDcnum : null,
            dcInfos : [],
            asynAllObserver : new BehaviorSubject()
        };
    },
    watch: {
    
        dcnum: {
            handler: function(newValue, oldValue) {
                
                const me = this;
                
                if( newValue ){
                    
                    if( Object.prototype.toString.call( newValue ) === '[object Object]' && newValue.id ){
                        me.returnObject = true  ;
                    }
                    me.setSelectedDc( newValue );
                }else{
                    
                    me.setSelectedDc( newValue );
                }
            }
        }
    },
    computed: {
        selectSize() {
            return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        selectDisabled() {
            return this.disabled || (this.elForm || {}).disabled;
        },
        selectReadonly() {
            return this.readonly || !this.filterable || this.multiple || (!isIE() && !isEdge() && !this.visible);
        },
        selectPopperAppendToBody(){
            return this.popperAppendToBody || false ;
        }
    },
    mounted: function () {
        
        const me = this;
        
        me.setSelectedDc( this.dcnum );

        me.dcInfos = [];
        DC.getAll().subscribe(
            ( response ) =>{

                if( response.data && response.data.length > 0  ){
                
                    me.dcInfos = response.data;
                    
                    if( me.dcInfos && me.linqWhere ){
                        
                        /*
                        let rule = "";
                        for ( let key in me.filterProperties ){
                            if( rule.length > 0 ){
                                rule += " && ";
                            }
                            rule = "String($." + key + ").indexOf( '" + me.filterProperties[key] + "' ) >= 0";
                        }
                        */

                        me.dcInfos = Enumerable.from( me.dcInfos ).where( me.linqWhere ).toArray();
                    }
                    
                    me.asynAllObserver.next( me.dcInfos );
                };
            } 
        );
    },
    methods: {
        handleClick(tab, event) {
        },
        
        handleSelectChange( value ){
            
            const me = this;
            
            let returnValue = me.getSelectedDc();
            
            me.$emit("change", returnValue );
        },
        
        setLabel( fullDcInfo ){
            
            const me = this;
            
            if( fullDcInfo ){
                
                if( me.labelPath ){
                    return me.getDcValueByPath( fullDcInfo, me.labelPath );
                }else{
                    return fullDcInfo.name;
                }
            }
            
            return null; 
        },
        setSelectedDc( input ){
            
            const me = this;
            
            me.getAllWithObserver().subscribe(
        
                ( data ) => {
                   
                    if( data == null ){
                        me.selectedDcnum = null
                        return;
                    }
                   
                    if( me.returnObject ){
                        if( input && input.id ){
                            me.selectedDcnum = input.id;
                        }
                        return;
                    }else if( me.valuePath && me.valuePath.length > 0 ){
                        for( let key in me.dcInfos ){
                            let pathValue = me.getDcValueByPath( me.dcInfos[key], me.valuePath );
                            
                            if( pathValue == input ){
                                me.selectedDcnum = me.dcInfos[key].id;
                                return;
                            }
                        }
                    }
                }
            ) 
                       
            me.selectedDcnum = input;
        },
        getSelectedDc(){
            
            const me = this;
            
            
            if( me.returnObject ){
            
                	
                Enumerable.from( me.dcInfos ).forEach(
                    ( item ) => {
                        if( item.id == me.selectedDcnum ){
                            return item;
                        }
                    }
                ); 
                
            }else if( me.valuePath && me.valuePath.length > 0 ){
                
                for( let key in me.dcInfos ){
                
                    if( me.dcInfos[key].id == me.selectedDcnum ){
                        let pathValue = me.getDcValueByPath( me.dcInfos[key], me.valuePath );
                        
                        return pathValue;
                    }
                } 
            }
            
            return me.selectedDcnum;
        },
        getDcValueByPath( dcInfo, path ){
        
            const me = this;
            
            let valuePath = "dcInfo." + path;
                        
            let pathValue = null;
            try{
                eval( "pathValue = " + valuePath );
            }catch( error ){
                console.error( 
                    "Failed to get DC info by path: " + path + ". Error is :" + error );
            }
            
            return pathValue;
        },
        getAll(){
        
            const me = this;
            
            return me.dcInfos;
        },
        getAllAsyn(){
        
            const me = this;
            
            const promise = new Promise(
                (resolve,reject) => {
                    me.asynAllObserver.subscribe(
                    
                        ( dcInfos ) => {
                            if( dcInfos ){
                                resolve( me.dcInfos );
                            }
                        }
                    );
                }
            );
            
            return promise;
        },
        getAllWithObserver(){
        
            const me = this;
            
            return me.asynAllObserver;
        },
        getCurrentValue(){
            
            const me = this;
            
            return me.dcnum;
        },
        setCurrentValue( input ){
            
            const me = this;
            
            me.dcnum = input;
        }
    }
}

</script>

/**
 dcinfo data like 
{
		"id": 4,
		"DCNUM": "536",
		"name": "536数据中心",
		"park_id": 4,
		"description": "536",
		"manager": "58,171,190,81,32",
		"leaders": "",
		"members": "57,119,56,190,170,84,240,96,171,48,353,365,39,32",
		"address": null,
		"tel": "4.2",
		"status": "RUNNING",
		"VALIDATION": "VALID",
		"dept_id": 35,
		"unit_power": 4.2,
		"itload": 1265,
		"totalload": 5000,
		"property": "{\"award\": 1.25, \"punish\": 2}",
		"ORGID": "ATHUB",
		"SITEID": "536"
	}, {
		"id": 1,
		"DCNUM": "219",
		"name": "219数据中心",
		"park_id": 2,
		"description": "219",
		"manager": "58,24,448,39",
		"leaders": "",
		"members": "40,179,39,67,34,163,178,82,245,271,272,312,335,404,425,411,22,251,31,515,516",
		"address": null,
		"tel": "3.52",
		"status": "RUNNING",
		"VALIDATION": "VALID",
		"dept_id": 4,
		"unit_power": 3.52,
		"itload": 490,
		"totalload": 2000,
		"property": "{\"award\": 1, \"punish\": 1.1}",
		"ORGID": "ATHUB",
		"SITEID": "219"
}

**/